import { useState, useCallback, ChangeEvent } from 'react';
import { createEmptyFormData, createEmptyPaymentFormState } from '../creditCardFormTypes';

const useFormData = () => {
  const [formData, setFormData] = useState(createEmptyFormData());
  const [formErrors, setFormErrors] = useState(createEmptyPaymentFormState());

  const removeFormError = useCallback((fieldName: string) => {
    setFormErrors((prevState: any) => {
      const newState = { ...prevState, [fieldName]: null };
      // delete newState[fieldName];
      return newState;
    });
  },
  [setFormErrors]);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>
  | ChangeEvent<HTMLSelectElement>) => {
    removeFormError(event.target.name);
    const property = event.target.name;
    const updatedFormState = {
      ...formData,
      ...{ [property]: event.target.value },
    };
    setFormData(updatedFormState);
  };

  const handleErrors = useCallback((error) => {
    setFormErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  }, [setFormErrors]);

  return {
    formData,
    setFormData,
    handleOnChange,
    formErrors,
    setFormErrors,
    handleErrors,
    removeFormError,
  };
};

export default useFormData;
